import deAtFlag from './de_at.vue'
import deDeFlag from './de_de.vue'
import frFlag from './fr.vue'
import enFlag from './en.vue'
import huFlag from './hu.vue'
import csFlag from './cs.vue'

// http://flag-icon-css.lip.is/
export default{
  deAtFlag,
  deDeFlag,
  frFlag,
  enFlag,
  huFlag,
  csFlag
}



// WEBPACK FOOTER //
// ./src/components/flags/index.js